import React, { Fragment } from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';

import { Item } from '../styles';

const Tabs = ({ tabs }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation('header');
  const { query = {} } = useRouter();

  return (
    <Fragment>
      {tabs.map(({ key, className, href, path, styleName, ['data-event']: event, target, rel }) => {
        const translation = t(key);

        if (!href) {
          return (
            <Item key={key}>
              <Link href={path}>{translation}</Link>
            </Item>
          );
        }

        return (
          <Item key={key} className={className}>
            <a
              href={href(language, query)}
              title={translation}
              data-event={event}
              target={target}
              rel={target === '_blank' ? 'noopener noreferrer' : ''}
              className={styleName}
            >
              {translation}
            </a>
          </Item>
        );
      })}
    </Fragment>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.array
};

export default Tabs;
